import React from 'react'
import { HeadingText, BodyText, Button } from '@paypalcorp/pp-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { getUpgradeBusinessAccountURL } from '../../../utils/app-utils'
import { getUserType } from '../../../utils/user-utils'

function UpgradeRequired() {
  const { user } = useApplicationContext()
  const accountType = getUserType(user)
  return (
    <div className="upgrade-card-center-content">
      <div className="upgrade-card-wrapper">
        <img
          src="https://www.paypalobjects.com/paypal-ui/pictograms/blue/svg/protection-blue.svg"
          alt="transaction-volume-blue"
          style={{ width: '100px' }}
        />
        <HeadingText
          size="sm"
          style={{ marginTop: '10px', textAlign: 'center' }}
          id="upgrade-required-title"
        >
          You are required to upgrade your account
        </HeadingText>
        <BodyText
          style={{ marginTop: '20px', textAlign: 'center' }}
          id="upgrade-required-description"
        >
          Upgrade your account to Paypal for Business account to accept invites
          and to switch to live mode
        </BodyText>
        <Button
          as="a"
          href={getUpgradeBusinessAccountURL({ accountType })}
          role="button"
          target="_blank"
          style={{ marginTop: '50px', marginBottom: '12px' }}
          data-dxa="upgrade_required,redirect,upgrade_account_required"
          data-testid="upgradeRequired"
        >
          Upgrade now
        </Button>
      </div>
    </div>
  )
}

export default UpgradeRequired
